document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.sliding-box-container');
  const slides = container.querySelectorAll('.sliding-box');
  const prevButton = document.querySelector('.slider-prev');
  const nextButton = document.querySelector('.slider-next');
  const section = document.querySelector('.sliding-box-section');
  let currentIndex = 0;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.style.display = i === index ? 'block' : 'none';
    });
    updateBackground(index);
  }

  function updateBackground(index) {
    const currentSlide = slides[index];
    const desktopBg = currentSlide.dataset.desktopBg;
    const mobileBg = currentSlide.dataset.mobileBg;
    const desktopHeight = section.dataset.desktopHeight;
    const mobileHeight = section.dataset.mobileHeight;
    
    if (window.innerWidth > 768) {
      section.style.backgroundImage = `url('${desktopBg}')`;
      if (desktopHeight === 'auto') {
        const imgHeight = currentSlide.dataset.desktopBgHeight;
        section.style.height = `${imgHeight}px`;
      } else {
        section.style.height = desktopHeight;
      }
    } else {
      section.style.backgroundImage = `url('${mobileBg}')`;
      if (mobileHeight === 'auto') {
        const imgHeight = currentSlide.dataset.mobileBgHeight;
        section.style.height = `${imgHeight}px`;
      } else {
        section.style.height = mobileHeight;
      }
    }

    // Ensure content is centered vertically
    const contentHeight = container.offsetHeight;
    const sectionHeight = section.offsetHeight;
    container.style.marginTop = `${(sectionHeight - contentHeight) / 2}px`;
  }

  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    showSlide(currentIndex);
  }

  function prevSlide() {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    showSlide(currentIndex);
  }

  nextButton.addEventListener('click', nextSlide);
  prevButton.addEventListener('click', prevSlide);

  // Apply custom font sizes and script vertical position
  const yearFontSize = section.dataset.yearFontSize;
  const scriptFontSize = section.dataset.scriptFontSize;
  const scriptVerticalPosition = section.dataset.scriptVerticalPosition;
  
  section.style.setProperty('--year-font-size', yearFontSize);
  section.style.setProperty('--script-font-size', scriptFontSize);
  section.style.setProperty('--script-vertical-position', scriptVerticalPosition);

  // Show the first slide initially
  showSlide(currentIndex);

  // Update background on window resize
  window.addEventListener('resize', () => {
    updateBackground(currentIndex);
  });
});